/**
 * カラープリセット選択
 * VITE_CONTRAST_MODE環境変数でプリセットを切り替える
 */

import type { ColorPreset, ContrastMode } from './types';
import { DEFAULT_PRESET } from './defaultPreset';
import { HIGH_CONTRAST_PRESET } from './highContrastPreset';
import { LOW_CONTRAST_PRESET } from './lowContrastPreset';

const CONTRAST_MODE_KEY = 'VITE_CONTRAST_MODE';

const PRESET_MAP: Readonly<Record<ContrastMode, ColorPreset>> = {
  default: DEFAULT_PRESET,
  high: HIGH_CONTRAST_PRESET,
  low: LOW_CONTRAST_PRESET,
} as const;

const getContrastMode = (): ContrastMode => {
  const mode: string = import.meta.env[CONTRAST_MODE_KEY] ?? '';
  if (mode === 'high' || mode === 'low') {
    return mode;
  }
  return 'default';
};

export const activePreset: ColorPreset = PRESET_MAP[getContrastMode()];

export type { ColorPreset, ContrastMode };
